import React from 'react';
import { imagePath } from '@common/services/images-service';

export const AuthTemplateLogo = () => {
  return (
    <>
      <img className="sign-in-logo" src={imagePath('./works-elm.svg')} />
      <style jsx>{`
        .sign-in-logo {
          width: 100px;
        }
      `}</style>
    </>
  );
};
